import * as React from "react";
import { Box, TextField } from "@mui/material";
import CclDrawer from "../../../components/common/cclDrawer/cclDrawer";
import CclDrawerActionBar from "../../../components/common/cclDrawer/cclDrawerActionBar";
import CclButton from "../../../components/common/cclButtons/cclButton";
import { useCreateNewListMutation } from "../../../services/cclTokenedGroupReportsApi";
import { UserParticipantList } from "../../../services/types/groupReportTypes";
import { UserClaimsService } from "../../../services/currentUserService/currentUserService";
import useLogAccessEvent from "../../../hooks/useLogAccessEvent";
import { AccessEventListDetails } from "../../../services/types/accessEventTypes";

export type CreateListPanelProps = {
    open: boolean;
    onClose: () => void;
    onCreateList: () => void;
    snackbarHandler: (severity: "error" | "warning" | "info" | "success", message: string) => void;
};

export const CreateListPanel: React.FC<CreateListPanelProps> = (props) => {

    const [listName, setListName] = React.useState("");

    const claimservice = new UserClaimsService();
    const { logEvent } = useLogAccessEvent();

    const [createNewList] = useCreateNewListMutation();

    const username = claimservice.GetCurrentUserEmail().split("@")[0].toUpperCase();

    const handleCreateNewList = () => {
        const newListRequest: UserParticipantList = {
            upL_ID: 0,
            participantListName: listName,
            createdByDateTime: new Date().toISOString(),
            createdByUsername: username,
            createdByUsernameFullName: claimservice.GetCurrentUserName(),
            createdByGroupName: claimservice.GetCurrentUserGroup(),
        };
        createNewList(newListRequest)
            .unwrap()
            .then(() => {
                const eventDetails: AccessEventListDetails = {
                    listName: listName,
                }
                logEvent("GroupReportListCreated", eventDetails);
                props.snackbarHandler("success", "List created");
                
                props.onCreateList();
                props.onClose();
            })
            .catch(() => {
                props.snackbarHandler("error", "Failed to create list");
            });
    }
    
    return (
        <CclDrawer 
            title={"Create List"} 
            open={props.open}
            onClose={props.onClose}
        >
            <TextField
                margin="normal" 
                label="List Name"
                fullWidth
                value={listName}
                onChange={(e) => setListName(e.target.value)}
            />
            <Box sx={{mt: "100%"}} />
            <CclDrawerActionBar >
                <CclButton onClick={handleCreateNewList} mode={"primary"}>Create</CclButton>
                <CclButton onClick={props.onClose} mode={"secondary"}>Cancel</CclButton>
            </CclDrawerActionBar>
        </CclDrawer>
    );
};

export default CreateListPanel;
